module.exports = "pegasus_template/assets/styleGroup3-twitter.png";